import React, {
    useState,
} from "react";

const EmailChipInput = ({
    value = [],
    onChange,
    placeholder,
}) => {

    const [email, setEmail] =
        useState("");

    const addEmail = () => {

        if (!email.trim())
            return;

        if (
            value.includes(email)
        )
            return;

        onChange([
            ...value,
            email.trim(),
        ]);

        setEmail("");
    };

    const removeEmail = (
        index
    ) => {

        const updated =
            value.filter(
                (_, i) =>
                    i !== index
            );

        onChange(updated);

    };

    return (

        <div className="border rounded p-2">

            <div className="d-flex flex-wrap gap-2 mb-2">

                {value.map(
                    (
                        item,
                        index
                    ) => (

                        <span
                            key={index}
                            className="badge bg-primary d-flex align-items-center"
                        >

                            {item}

                            <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                style={{
                                    fontSize:
                                        8,
                                }}
                                onClick={() =>
                                    removeEmail(
                                        index
                                    )
                                }
                            />

                        </span>

                    )
                )}

            </div>

            <input
                className="form-control border-0 shadow-none"
                placeholder={
                    placeholder
                }
                value={email}
                onChange={(e) =>
                    setEmail(
                        e.target
                            .value
                    )
                }
                onKeyDown={(
                    e
                ) => {

                    if (
                        e.key ===
                        "Enter"
                    ) {

                        e.preventDefault();

                        addEmail();

                    }

                }}
            />

        </div>

    );

};

export default EmailChipInput;